import { render, staticRenderFns } from "./DynamicLayout.vue?vue&type=template&id=3ede5017"
import script from "./DynamicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports